import { action, makeObservable, observable, runInAction } from 'mobx';
import type { EventsSchemaDto } from '@web/common';
import { getEvents } from '../request/authenticated-requests/events';
import { setupMobX } from '../util/setupMobX';
import { showErrorNotification } from '../component/notification';

export class EventStore {
  @observable public events: EventsSchemaDto = [];
  @observable public loadingEvents: boolean = false;

  constructor() {
    makeObservable(this);
  }

  @action public loadEvents = () => {
    this.loadingEvents = true;
    getEvents()
      .then((events) => {
        runInAction(() => {
          this.loadingEvents = false;
          this.events = events.sort((a, b) => a.title.localeCompare(b.title));
        });
      })
      .catch(() => {
        showErrorNotification();
        this.loadingEvents = false;
      });
  };
}

const { provider, useStore } = setupMobX<EventStore>();
export const useEventStore = useStore;
export const EventStoreProvider = provider;
